import { render, staticRenderFns } from "./ComboDetail.vue?vue&type=template&id=4128e8b4&scoped=true&"
import script from "./ComboDetail.vue?vue&type=script&lang=js&"
export * from "./ComboDetail.vue?vue&type=script&lang=js&"
import style0 from "./ComboDetail.vue?vue&type=style&index=0&id=4128e8b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4128e8b4",
  null
  
)

export default component.exports